export const donationBankInfoList = {
  groom: [
    {
      name: "하룡길(신랑)",
      bankName: "카카오뱅크",
      bankNumber: "3333-21-3713740",
    },
    {
      name: "하주형(혼주)",
      bankName: "부산은행",
      bankNumber: "062-02-013531-4",
    },
    {
      name: "신희숙(혼주)",
      bankName: "부산은행",
      bankNumber: "060-12-027990-7",
    },
  ],
  bride: [
    { name: "강지은(신부)", bankName: "부산은행", bankNumber: "105120681603" },
    { name: "강호춘(혼주)", bankName: "국민은행", bankNumber: "102010792353" },
    { name: "이미정(혼주)", bankName: "부산은행", bankNumber: "105120357563" },
  ],
};
